import '../../../ProductCard/ProductCard.scss';
import './AoLovesWrapper.scss';

import classnames from 'classnames';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { useIsSmallOnly } from '../../../../hooks/mediaQueries';
import { useTheme } from '../../../../hooks/useTheme';
import TRANSLATIONS from '../../../../translations/translations@default.json';
import AOWeRecommendSmile from '../../../ProductCard/AOWeRecommendSmile';
import { Context } from '../../store/store';
import Wrapper from './Wrapper';

const AoLovesWrapper = ({ product, index }) => {
	const [state] = useContext(Context);
	const { loaded } = state;

	const theme = useTheme('aoLoves');

	const isSmallOnly = useIsSmallOnly();

	const { CustomCategoriesEnabled } = useSelector(
		({ experimentSwitches }) => experimentSwitches
	);

	const isEnhancedCardLayout = product.ShouldShowEnhancedCard;

	const props = isSmallOnly
		? {
				transform: 'scale(1.5)',
				left: '-80px',
		  }
		: {
				transform: 'scale(2)',
				right: '240px',
		  };

	return (
		<li
			id={product.Code}
			className={classnames(
				'relative flex flex-col h-full w-full pb-4 my-2 overflow-hidden rounded-lg ao-loves-wrapper',
				{
					'bg-gray-20': !loaded,
					'wrapper--hover': CustomCategoriesEnabled,
					'px-2 xl:px-4 ': !isEnhancedCardLayout,
				}
			)}
			style={{
				WebkitTransform: 'translateZ(0)',
				backgroundImage: theme.desktopBackground,
				backgroundSize: 'cover',
			}}>
			<div
				className={classnames('flex', {
					'pl-2': isEnhancedCardLayout,
				})}>
				<div className="ico ico-ao-loves text-white py-4 text-xl mr-2"></div>
				<div
					className={classnames('text-title-lg py-4 mr-2 leading-none', {
						[`${theme.text}`]: loaded,
						'text-gray-20': !loaded,
					})}>
					AO Loves
				</div>
				<div className="text-white text-body-sm py-4 hover-text">
					Top tech we know you&apos;ll love
				</div>
			</div>

			<Wrapper
				{...{ product, index, isFeatured: true, isEnhancedCardLayout }}
			/>
		</li>
	);
};

export default AoLovesWrapper;
